declare namespace Serenity {

    interface UserDefinition {
        CompanyId: number;
        CompanyCode: string;
        FinancialYearId: number;
        FinYearCode: string;
        UserId: number;
        CurrencyId: number;
        TaxGroupId: number;
        StartDate: Date;
        EndDate: Date;
    }

    interface ButtonEditorOptions {
        title?: string;
        emptyLabel?: boolean;
        cssClass?: string;
        primaryBtn?: boolean;
        successBtn?: boolean;
        warningBtn?: boolean;
        dangerBtn?: boolean;
    }
    class ButtonEditor extends Serenity.Widget<ButtonEditorOptions> {
        onClick: (eventObject: JQueryEventObject) => void;
        constructor(container: JQuery, options: ButtonEditorOptions);
        private updateElementContent;
    }

    interface BarCodeField {
        name: string;
        title: string;
    }

    namespace GridUtils {
        function addBarcodeScanner(container: JQuery, onSearch: (p1: string, p2: string, done: (p3: boolean) => void) => void, fields?: BarCodeField[]): void;
    }

    interface PersistedDialogField {
        id: string;
        value?: string;
        visible?: boolean;
        readonly?: boolean;
        required?: boolean;
    }

    interface PersistedDialogSettings {
        Fields: PersistedDialogField[];
    }

}

declare namespace Slick {
    interface Grid {
        onRender?: Slick.Event;
        onRendered: Slick.Event;
    }
}

declare namespace TabAurous {
    const enum ItemSelection {
        JMS = 1,
        JM = 2,
        JS = 3,
        MS = 4,
        J = 5,
        M = 6,
        S = 7,
    }

    export const ItemColumnTextPrefix = 'Items';
    export const BOMColumnTextPrefix = 'Items';
    export const TransColumnTextPrefix = 'Items';
}
